// extracted by mini-css-extract-plugin
export var quantityInput = "_ia-0";